/* eslint-disable react/no-danger */
import classNames from 'classnames';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { forTemplate } from 'app/common/lib/util/i18n';
import { Announcement as AnnouncementType } from './helpers';
import React from 'react';
import styles from './Announcement.less';

const format = forTemplate('announcement');

export const classNamesForType = (type: string) => {
  return {
    [styles.announcement]: true,
    [styles[`announcement-${type}`]]: !!type,
  };
};

const sendAnalytics = () => {
  trackUe({
    category: Noun.HEADER,
    verb: Verb.OPENS,
    directObj: Noun.LANDING_TAB,
    context: {
      landingtab: 'Opened Announcement Link',
    },
  });
};

export const Announcement: React.FunctionComponent<AnnouncementType> = ({
  url,
  title,
  html,
  type,
}) => (
  <div className={classNames(classNamesForType(type))}>
    <h3 className={styles.announcementHeader}>
      {url ? (
        <a
          className={styles.announcementHeaderLink}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={sendAnalytics}
        >
          {title}
        </a>
      ) : (
        title
      )}
    </h3>
    <p dangerouslySetInnerHTML={{ __html: html }} />
    {url && (
      <p className={styles.quiet}>
        <a href={url} target="_blank" rel="noopener noreferrer">
          {format('read-more-ellipsis')}
        </a>
      </p>
    )}
  </div>
);
